module.exports = __webpack_public_path__ + "static/media/entidades_de_soporte.f4826fbe.jpg";